/**
 * Imports
 * @internal
 * @ignore
 */
import { Divider } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { useStyles } from '@material-ui/pickers/views/Calendar/SlideTransition'
import { ReactElement, useState } from 'react'

/**
 * Types
 * @internal
 * @ignore
 */
interface InfoTitleProps {
  children?: null | string
  title?: null | string
  infoComponent?: any
}

/**
 * Chart info dialog.
 *
 * @param props InfoDialog props.
 * @param props.title Dialog Title.
 * @param props.infoComponent Info component or text to render in dialog body.
 * @param props.children Children.
 * @returns Info Dialog Component.
 */
const InfoDialog = ({ title, infoComponent, children }: InfoTitleProps): ReactElement => {
  const classes = useStyles() as any
  let isComponent = true

  if (typeof infoComponent === 'string') {
    isComponent = false
  }
  const Component = isComponent ? (infoComponent || (() => null)) : undefined
  const [open, setOpen] = useState(false)

  return (
    <Box display="flex">
      {infoComponent &&
        <Box>
          <IconButton size="small" onClick={() => setOpen(true)}>
            <InfoOutlinedIcon />
          </IconButton>
        </Box>
      }

      <Dialog open={open} onClose={() => setOpen(false)}>
        <Box p={2}>
          {title &&
            <>
              <Box flexGrow={1}>
                <Typography variant="body1" color="textSecondary" className={classes.subtitle}>{title ?? children}</Typography>
              </Box>
              <Divider />
            </>
          }
          {isComponent &&
            <Component /> ||
            <p> {infoComponent}</p>
          }
        </Box>
      </Dialog>
    </Box>
  )
}

export default InfoDialog
